import { FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper2: React.FC<Props> = (props: Props) => {
  const { language, translate } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const { novoUsuario } = props;
  const methods = useFormContext();

  const handleAutoSave = () => {
    document.getElementById('btnSavePPC')?.click();
  };

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h4" component="h2">
            {translate('referencia')}
          </Typography>
        </Grid>
        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate('referenciaP1')}
          </Typography>
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <Controller
            control={methods.control}
            name='referencia'
            render={({ field: { ref, ...field } }) => (
              <TextField
                sx={{ width: "100%" }}
                id="standard-multiline-static"
                {...field}
                inputRef={ref}
                value={field.value}
                label={translate('referencia')}
                variant="outlined"
                multiline
                rows={8}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

      </Grid>
    </>
  );
};

export default PPCStepper2;
